module.exports = __webpack_public_path__ + "static/media/teamwork_samard.644731b6.png";